import { render, staticRenderFns } from "./ResetPasswordPage.vue?vue&type=template&id=17ee7018&scoped=true"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=ts"
import style0 from "./ResetPasswordPage.vue?vue&type=style&index=0&id=17ee7018&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ee7018",
  null
  
)

export default component.exports